import React from "react";
import PropTypes from "prop-types";
import { Treemap, ResponsiveContainer, Tooltip } from "recharts";

import { lightenDarken } from "utils/color";

const CustomizedContent = ({
  depth,
  x,
  y,
  width,
  height,
  name,
  index,
  length,
}) => {
  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          fill:
            depth < 2 ? lightenDarken(index / length, "#004A84") : "#ffffff00",
          strokeWidth: 0,
        }}
      />
      {depth === 1 ? (
        <text
          x={x + width / 2}
          y={y + height / 2 + 7}
          textAnchor="middle"
          fontSize={12}
          fill={index / 10 > 0.5 ? "#000" : "#fff"}
        >
          {name}
        </text>
      ) : null}
    </g>
  );
};

CustomizedContent.propTypes = {
  depth: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  index: PropTypes.number,
  name: PropTypes.string,
  length: PropTypes.number,
  allData: PropTypes.any,
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="treemap-custom-tooltip">
        <b>{payload[0].payload.name}</b>
        <p>{payload[0].payload.noOfTrades}</p>
        <p>{payload[0].payload.winningTrades}</p>
        <p>{payload[0].payload.losingTrades}</p>
        <p>{payload[0].payload.profit}</p>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

export const TreeMapChart = ({ data = [], height = "350px" }) => {
  return (
    <div style={{ height }} className="text-center">
      <ResponsiveContainer>
        <Treemap
          data={data}
          dataKey="tileSize"
          ratio={3 / 1}
          content={<CustomizedContent length={data.length} allData={data} />}
        >
          <Tooltip content={CustomTooltip} />
        </Treemap>
      </ResponsiveContainer>
    </div>
  );
};

TreeMapChart.propTypes = {
  data: PropTypes.array,
  height: PropTypes.string,
};
